<template>
  <ux-atoms-link
    :aria-label="buttonAriaLabel"
    :class="['Map-list-switch', 'Button Button--primary', { 'Map-list-switch--desktop': isDesktop, 'Map-list-switch--map': currentView === 'map' }]"
    :href="buttonSwitchLink"
  >
    <ux-atoms-typo as="span" class="Map-list-switch__text Map-list-switch__text--mobile" v-if="!isDesktop" variant="inherit">
      {{ buttonSwitchTranslationMobile }}
    </ux-atoms-typo>
    <ux-atoms-typo as="span" class="Map-list-switch__text Map-list-switch__text--desktop" v-else variant="inherit">
      {{ buttonSwitchTranslationDesktop }}
    </ux-atoms-typo>
    <ux-atoms-icon :name="buttonSwitchIcon" class="Map-list-switch__icon" size="s" />
  </ux-atoms-link>
</template>
<script setup lang="ts">
import { parseQueryParams, urlQueryParams } from '~/helpers/urlQueryParams';

export interface MapListSwitchProps {
  currentView?: 'list' | 'map';
  isDesktop?: boolean;
}

const props = withDefaults(defineProps<MapListSwitchProps>(), {
  currentView: 'list',
  isDesktop: false
});

const { t } = useI18n();
const route = useRoute();

const query = computed(() => parseQueryParams(route.query));

const queryParams = computed(() => {
  return query.value ? `?${urlQueryParams(query.value)}` : '';
});

const linkToMap = computed(() => `${route.path}/map`);

const linkToList = computed(() => {
  const mapIndex = route.path.indexOf('/map');
  return mapIndex !== -1 ? `${route.path.substring(0, mapIndex)}` : `${route.path}`;
});

const buttonSwitchIcon = computed(() => {
  return props.currentView === 'list' ? 'map' : 'list';
});

const buttonSwitchLink = computed(() => {
  return props.currentView === 'list' ? `${linkToMap.value}${queryParams.value}` : `${linkToList.value}${queryParams.value}`;
});

const buttonSwitchTranslationDesktop = computed(() => {
  return props.currentView === 'list' ? t('ux.molecules.mapListSwitch.seeMap') : t('ux.molecules.mapListSwitch.seeList');
});

const buttonSwitchTranslationMobile = computed(() => {
  return props.currentView === 'list' ? t('ux.molecules.mapListSwitch.map') : t('ux.molecules.mapListSwitch.list');
});

const buttonAriaLabel = computed(() => {
  return props.currentView === 'list' ? t('ux.molecules.mapListSwitch.seeMapAria') : t('ux.molecules.mapListSwitch.seeListAria');
});
</script>
<style lang="scss" scoped>
@use 'MapListSwitch.scss';
</style>
